<template>
  <v-container>

    <v-card>
      <v-toolbar flat color="blue accent-2" class="white--text">
        <v-btn to="/" icon text>
          <v-icon small class="white--text">mdi-home</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h3 class="font-weight-light">Ciudades</h3>
        </v-toolbar-title>
      </v-toolbar>


      <v-card-text>

        <loader v-if="isloading"></loader>

        <v-row dense>
          <v-col cols="12" md="3">
            <v-text-field v-model="search" outlined small dense label="Busqueda"></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>

          <v-col cols="12">
            <v-data-table :search="search" :headers="headers" :items="items" disable-pagination hide-default-footer item-key="key" class="elevation-1 mt-6">

              <template v-slot:item.name="{item}">
                <v-text-field v-if="editar_id == item.id" v-model="item.name" outlined small dense hide-details append-icon="mdi-content-save" @click:append="saveItem(item)"></v-text-field>
                <span v-else>{{item.name}}</span>
              </template>

              <template v-slot:item.status="{item}">
                <v-chip @click="changeStatus(item)" :color="item.status ? 'green' : 'red'" class="white--text">
                  {{item.status ?  'Visible' : 'Oculto'}}
                </v-chip>
              </template>

              <template v-slot:item.actions="{item}">
                <v-icon @click="editarCiudad(item)" small class="mr-2" color="blue">
                  mdi-pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import {
    costo_service
  } from '~/costo_service'


  export default {
    data() {
      return {
        search: null,

        editar_id: null,

        items: [],

        headers: [{
            text: 'Nombre',
            value: 'name',
            width: 350,
          },
          {
            text: 'Estado',
            value: 'status',
          }, {
            text: '',
            value: 'actions',
          }
        ],
      }
    },

    created() {
      this.getPreciosCiudades()
    },


    methods: {
      saveItem(item) {
        costo_service.update_city(item.id, {
          name: item.name
        }).then(res => {
          let index = this.items.findIndex(x => x.id == item.id)
          if (index > -1) {
            this.$set(this.items, index, res.data)
          }
          this.editar_id = null
          this.$toast.sucs('Ciudad actualizada con exito')
        })
      },
      changeStatus(item) {
        this.updateCity(item)
      },
      updateCity(item) {
        costo_service.update_city(item.id, {
          status: !item.status
        }).then(res => {
          let index = this.items.findIndex(x => x.id == item.id)
          if (index > -1) {
            this.$set(this.items, index, res.data)
          }
          this.editar_id = null
          this.$toast.sucs('Ciudad actualizada con exito')
        })
      },
      editarCiudad(item) {
        this.editar_id = item.id
      },
      getPreciosCiudades() {
        costo_service.get_cities().then(res => {
          this.items = res.data
          console.log(res.data)
        }, res => {
          this.$toast.error('Error consultando clientes')
        })
      },

      /*updateContacto(item) {
        costo_service.update_contacto(item.id, item).then(res => {
          let index = this.items.indexOf(item)
          this.$set(this.items, index, res.data)
          this.$toast.sucs('contacto actualizado con exito')
        }, res => {
          this.$toast.error('Error actualizando clientes')
        })
      }*/
    },

    filters: {
      format_hour(hour_24_format) {
        return moment(`01-01-2023 ${hour_24_format}:00`).format('hh:mm a')
      },

      format_date(db_date) {
        return moment(db_date).format('dddd, D MMMM - Y hh:mm a')
      },
    },
    computed: {
      isloading() {
        return this.$store.getters.getloading
      },
      errors() {
        return this.$store.getters.geterrors
      },
      user() {
        return JSON.parse(localStorage.getItem('user'))
      }
    }
  }
</script>